import { GenericTradeParams } from '@ui/features/Trade/types';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { usePriceLatest } from '@ui/hooks/price/usePriceLatest';
import BigNumber from 'bignumber.js';

import { useTradePairInfosByPairBase } from '../../../hooks/trade/useTradePairInfos';
import { useLiqLostP } from './useLiqLostP';

export const useLiqPrice = ({ genericTradeParams }: GenericTradeParams) => {
  const collateralMarketPrice = usePayTokenPriceLatest(
    genericTradeParams.collateralToken,
  );

  const tradePairInfos = useTradePairInfosByPairBase(
    genericTradeParams.pair.address,
  );
  const positionLiqLostP = useLiqLostP({ genericTradeParams });
  const pairPrice = usePriceLatest(genericTradeParams.pair.baseSymbol);

  const liqPrice =
    tradePairInfos?.feeConfig && pairPrice && tradePairInfos
      ? genericTradeParams.getLiquidationPrice({
          collateralMarketPrice: collateralMarketPrice ?? new BigNumber(0),
          liqLostP: positionLiqLostP,
          feeConfig: tradePairInfos?.feeConfig,
          pairMarketPrice: pairPrice,
          tradePair: tradePairInfos,
        })
      : undefined;

  return liqPrice;
};
